var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"input",attrs:{"type":"file"},on:{"change":_vm.submitFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }